/**
 * cn() — clsx + tailwind-merge utility
 *
 * Tailwind classlarni dynamic ravishda birlashtirish va konflikt'larni hal qilish
 *
 * @example
 *   cn('px-4 py-2', isActive && 'bg-primary', 'px-6')  // 'py-2 bg-primary px-6'
 *   cn('text-red-500', someProp && 'text-blue-500')    // konflikt: blue qoladi
 */

import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
